import { ChavesArmazenamentoLocal } from '@domain/armazenamento-local'

export const atualizarSessionToken = (token: string) => {
  localStorage.setItem(ChavesArmazenamentoLocal.SESSION_TOKEN, token)
}
